import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Avatar as MUIAvatar } from '@mui/material';

import useUserImage from '../../hooks/useUserImage';

const Avatar = ({ color = 'default', src, children, sx, ...other }) => {
  const theme = useTheme();

  const [newSrc] = useUserImage(src);

  if (color === 'default') {
    return (
      <MUIAvatar sx={sx} {...other}>
        {children}
      </MUIAvatar>
    );
  }

  return (
    <MUIAvatar
      src={newSrc}
      sx={{
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].main,
        ...sx,
      }}
      {...other}
    >
      {children}
    </MUIAvatar>
  );
};

Avatar.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
  ]),
};

export default Avatar;
